import { TranslateFn } from 'hooks/useTranslate';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';
import { sortPartnerCategoriesByDefault } from 'modules/partners/utils/mapPartnerCategoriesToTable';

import { PartnerCategory } from 'types/Partner';

export const mapPartnerCategoriesToSelectOptions = (
  categories: PartnerCategory[],
  translate: TranslateFn
): CustomAsyncSelectOption[] =>
  [...categories]
    .sort(sortPartnerCategoriesByDefault)
    .map((c) => ({
      value: c._id,
      label: c.isDefault ? translate(c.name) : c.name,
    }));
